import { chunk } from "lodash-es"
import React, { useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import SummaryCard from "components/Templates/SummaryCard"
import {
  CLOSE_DISPATCH_SUMMARY,
  useSelectedOrdersArray,
} from "store/dispatch.redux"
const DispatchSummary = () => {
  const vehicleCapacity = useSelector(
    (state: any) => state.dispatch.vehicle?.vehicleType?.capacity
  )
  const isOpen = useSelector(
    (state: any) => state.dispatch.isDispatchSummaryOpen
  )
  const orders = useSelectedOrdersArray()
  const { ordered: items, totalWeight } = useMemo(() => {
    let totalWeight = 0
    const allSellableItems = []
    orders.forEach(ord => {
      if (ord?.orderItems) {
        allSellableItems.push(...ord?.orderItems?.filter(i => i?.isSelected))
        totalWeight += ord.totalWeight
      }
    })

    const ordered = allSellableItems?.reduce((prev, i) => {
      const item = i?.sellableItem
      const prevQty = prev?.[item?.id]?.quantity
      const quantity = i.newQuantity ?? i.quantity
      return {
        ...prev,
        [item?.id]: {
          id: item?.id,
          name: item?.name,
          quantity: prevQty ? prevQty + quantity : quantity,
        },
      }
    }, {})

    return { ordered, totalWeight }
  }, [orders])
  const chunks = items ? chunk(Object.values(items), 2) : []
  const dispatch = useDispatch()

  const total =
    items && Object.values(items).reduce((s, i: any) => s + i.quantity, 0)

  return (
    <SummaryCard
      title="Items Summary"
      onClick={() => {
        dispatch({
          type: CLOSE_DISPATCH_SUMMARY,
        })
      }}
      isOpen={isOpen}
    >
      <section>
        <div className="item-container">
          {chunks?.map((i, row) => {
            return (
              <div
                key={row}
                className="grid grid-cols-12 gap-4 text-sm vt-muted"
              >
                {i.map((i: any, col) => {
                  return (
                    <div key={`${row}-${col}`} className="col-span-6">
                      <p>
                        {i?.name} -{" "}
                        <span className="font-bold vt-dark">{i.quantity}</span>{" "}
                        Units
                      </p>
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
      </section>
      <div>
        <hr />
        <div className="flex justify-between">
          <div>
            Vehicle Payload -{" "}
            <span className="font-bold vt-dark">
              {totalWeight || 0} / {vehicleCapacity}
            </span>{" "}
            Kg
          </div>
          <div>
            Total - <span className="font-bold vt-dark">{total || 0}</span>{" "}
            Units
          </div>
        </div>
      </div>
    </SummaryCard>
  )
}

export default DispatchSummary
